import { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const initialState = {
    role: "",
    uid: "",
    name: "",
    email: "",
  };
  const [userState, setUserState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  return (
    <AuthContext.Provider
      value={{ userState, setUserState, initialState, loading, setLoading }}
    >
      {children}
    </AuthContext.Provider>
  );
};
